import React from 'react';
import { Icon } from 'semantic-ui-react';
import { useIntl } from 'react-intl';

const WaitingIcon = ({ className }) => {
  const intl = useIntl();
  return (
    <Icon
      className={className}
      name="hourglass outline"
      title={intl.formatMessage({ id: 'status.waiting' })}
    />
  );
};

export default WaitingIcon;
